import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpClient } from '@angular/common/http';
import { ApplicantDocument } from '@app/model/applicantDocument';
import { environment } from '@environments/environment';
import { ApplicantDocumentSerializer } from '@app/model/serializer/applicantDocument-serializer';


@Injectable({ providedIn: 'root' })
export class ApplicantDocumentService extends ApiService<ApplicantDocument> {

  constructor(httpClient: HttpClient) {
    super(httpClient,
      environment.apiUrl,
      'applicant-document',
      new ApplicantDocumentSerializer());
  }
}
